import type { OrderTypeTabSelectedProperties } from '@/ampli';

import type { AdvancedOrderType } from '@/constants/advancedOrder';

import type { CheckoutMode } from '@/hooks/useCheckoutMode';

type AmpliSwapOrderType = OrderTypeTabSelectedProperties['swap_order_type'];

/**
 * Maps checkout mode (and Advanced order type, when relevant) onto Amplitude
 * `swap_order_type`. Do not hand-edit generated `src/ampli/index.ts`.
 */
export function toAmpliSwapOrderType(
  mode: CheckoutMode,
  orderType: AdvancedOrderType = 'limit',
): Exclude<AmpliSwapOrderType, 'wrap'> {
  switch (mode) {
    case 'cross-chain':
      return 'cross_chain';
    case 'market':
      return 'market';
    case 'advanced':
      switch (orderType) {
        case 'limit':
          return 'limit';
        case 'stop-loss':
          return 'stop_loss';
        case 'take-profit':
          return 'take_profit';
        default: {
          const exhaustiveType: never = orderType;
          return exhaustiveType;
        }
      }
    default: {
      const exhaustiveMode: never = mode;
      return exhaustiveMode;
    }
  }
}
